import { MAX_FILE_SIZE_MB } from './configs';

const ErrorMessages = {
  resultEmpty: 'Result is empty',
  download: 'Failed to download file',
  deleteFiles: 'Failed to delete files',
  driveFile: 'Failed to load drive file',
  loadDriveFiles: 'Failed to load drive files',
  saveDriveFile: 'Could not save. Please try again.',
  driveStorageFull:
    'Your Picsart storage is full. Free up space and try again.',
  submitWebHook: 'Failed to submit webhook',
  changeFileName: 'Failed to change file name',
  saveReaction: 'Could not save your reaction',
  shareLink: 'Could not create a share link',
  copyLink: 'Could not copy the link',
  shareSheet: 'Could not open the share options',
  uploadToCDN: 'Failed to upload file into CDN',
  presetCreditCount: 'Could not get preset credit count',
  fileTooLarge: `File size exceeds the maximum limit of ${MAX_FILE_SIZE_MB}MB`,
  loadLibrary: 'Failed to load library',
  loadLibraryTabs: 'Failed to load library tabs',
  loadPreset: 'Failed to load preset details',
  // Generation errors
  generationFailed: 'Generation failed. Please try again.',
  prohibitedContent:
    'Your request could not be processed due to content restrictions. Please modify your input and try again.',
  generationTimeout:
    'Generation is taking longer than expected. Please try again.',
  rateLimited: 'Too many requests. Please wait a moment and try again.',
  serverError: 'Service temporarily unavailable. Please try again later.',
  networkError: 'Connection error. Please check your internet and try again.',
  noResultUrl:
    'Generation completed but no result was returned. Please try again.',
};

export { ErrorMessages };
